import { IconButton, styled } from '@mui/material';

export const StyledCollapseButton = styled(IconButton)({
	width: '24px',
	height: '24px',
	padding: '0px',
});
